webpackJsonp([28258812539611],{

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(17);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _components = __webpack_require__(8);
	
	var _data = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'A Trust is a legal entity created by a party (the trustor) through which a second party (the trustee) holds the right to manage the trustor\'s assets or property.'
	    )
	  );
	};
	
	var fieldSets = [{
	  legend: 'Trust Information',
	  fields: new Map([['orgName', {
	    label: 'Trust Name',
	    title: 'Please provide a valid trust name',
	    'data-help-title': 'Name of Trust',
	    'data-help-text': 'Please provide the name of the trust.',
	    validation: Yup.string().required('Please provide a valid trust name')
	  }], ['orgType', {
	    label: 'Trust Type'
	  }]])
	}, {
	  legend: 'Creator/Grantor Information',
	  fields: new Map([['firstName', {
	    label: 'Grantor First Name',
	    'data-help-title': 'Grantor Information',
	    'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.'
	  }], ['middleName', {
	    label: 'Grantor Middle Name',
	    'data-help-title': 'Grantor Information',
	    'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.'
	  }], ['lastName', {
	    label: 'Grantor Last Name',
	    'data-help-title': 'Grantor Information',
	    'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.'
	  }], ['socialSecurity', {
	    label: 'Grantor Social Security Number',
	    'data-help-title': 'Grantor Information',
	    'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.'
	  }], ['verifySocialSecurity', {
	    label: 'Grantor Verify SSN',
	    'data-help-title': 'Grantor Information',
	    'data-help-text': 'The Grantor is the person or business who is making the grant to create the trust. The Grantor can also sometimes be known as the Owner, Trustor, Donor, Settlor, Conservator, Guardian, or Custodian.<br><br>If there is more than one Grantor, list the primary one. Or if all Grantors are equal, list only one.<br><br>The Grantor and Trustee of a trust may sometimes be the same person.'
	  }], ['suffix', {
	    initial: 'DDS'
	  }]])
	}, {
	  legend: 'Trustee',
	  fields: new Map([['trusteeFirstName', {
	    component: _components.TextInput,
	    label: 'Trustee First Name',
	    title: 'Please provide a valid name',
	    'data-help-title': 'Trustee Information',
	    'data-help-text': 'A Trustee manages the assets of the Trust. There may be more than one Trustee (but only list one).',
	    validation: Yup.string().required('Please provide a valid name')
	  }], ['trusteeMiddleName', {
	    component: _components.TextInput,
	    label: 'Trustee Middle Name',
	    placeholder: 'Optional',
	    'data-help-title': 'Trustee Information',
	    'data-help-text': 'A Trustee manages the assets of the Trust. There may be more than one Trustee (but only list one).',
	    validation: Yup.string()
	  }], ['trusteeLastName', {
	    component: _components.TextInput,
	    label: 'Trustee Last Name',
	    title: 'Please provide a valid name',
	    'data-help-title': 'Trustee Information',
	    'data-help-text': 'A Trustee manages the assets of the Trust. There may be more than one Trustee (but only list one).',
	    validation: Yup.string().required('Please provide a valid name')
	  }], ['trusteeTitle', {
	    component: _components.TextInput,
	    label: 'Trustee Title',
	    placeholder: 'Trustee',
	    title: 'Please provide a valid title',
	    'data-help-title': 'Trustee Information',
	    'data-help-text': 'A Trustee manages the assets of the Trust. There may be more than one Trustee (but only list one).',
	    validation: Yup.string().required('Please provide a valid title')
	  }]])
	}, {
	  legend: 'Trustee Address Information',
	  fields: new Map([['businessAddress', {
	    label: 'Trustee Address'
	  }], ['businessCity', {
	    label: 'Trustee City'
	  }], ['businessState', {
	    label: 'Trustee State'
	  }], ['businessZip', {
	    label: 'Trustee Zip Code'
	  }], ['businessCounty', {
	    label: 'Trustee County'
	  }], ['mailingAddressDiff', {
	    label: 'Mailing address different than Business address?'
	  }]])
	}, {
	  legend: 'Trust Dates',
	  fields: new Map([['businessDateStart', {
	    label: 'Date business started or acquired'
	  }], ['businessClosingMonth']])
	}, {
	  legend: 'Contact Information',
	  fields: new Map([['customerContactPhone'], ['customerContactEmail', {
	    label: 'Contact E-mail'
	  }], ['customerContactEmailVerify', {
	    label: 'Verify Contact E-mail'
	  }]])
	}];
	
	var TrustApplicationPage = function TrustApplicationPage(props) {
	  return _react2.default.createElement(_components.ApplicationFlow, _extends({
	    step: 2,
	    title: 'Trust Application',
	    documentType: _data.documentTypes.TRUST,
	    description: Description,
	    fieldSets: fieldSets
	  }, props));
	};
	
	exports.default = TrustApplicationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-trust-application-js-67d07490d33591aa51c5.js